/**
 * Build a human-readable toast message from notify API response stats.
 * Works for SMS, Email, and Push endpoints that return a stats object.
 */
export function buildNotifyMessage(res) {
    const stats = res && res.data && res.data.result;
    if (!stats || typeof stats !== 'object' || Array.isArray(stats)) {
        return res && res.data && res.data.status_message
            ? res.data.status_message
            : 'Notification sent';
    }

    const parts = [];

    if (stats.total_employees !== undefined) {
        parts.push(stats.total_employees + ' employee' + (stats.total_employees !== 1 ? 's' : ''));
    }

    if (stats.sms_sent > 0) parts.push('SMS: ' + stats.sms_sent + ' sent');
    if (stats.sms_no_phone > 0) parts.push(stats.sms_no_phone + ' no phone');

    if (stats.email_sent > 0) parts.push('Email: ' + stats.email_sent + ' sent');

    if (stats.push_sent > 0) parts.push('Push: ' + stats.push_sent + ' sent');
    if (stats.push_no_token > 0) parts.push(stats.push_no_token + ' no app');
    if (stats.push_failed > 0) parts.push(stats.push_failed + ' push failed');

    if (stats.skipped_stopped > 0) parts.push(stats.skipped_stopped + ' blocked (stop)');

    return parts.length > 0 ? parts.join(', ') : 'Notification sent';
}
